<template>
  <div class="container">
    <Container :active_path="path" :plate="'项目巡览'">
      <div class="base-warp">
        <div class="head">
          <el-form :model="search" ref="form" label-width="80px" :inline="true" size="normal">
            <el-form-item label="名称">
              <el-input v-model="search.name" size="mini" placeholder="请输入项目配套图片名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="mini" @click="confirm">搜索</el-button>
              <el-button type="primary" size="mini" @click="dialogVisible = true">添加项目配套图片</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-dialog v-bind="$attrs" v-on="$listeners" :visible.sync="dialogVisible" title="项目配套" width="30%">
            <el-row :gutter="15">
              <el-form ref="elForm" :model="formData" :rules="rules" size="small" label-width="100px"
                label-position="left">
                <el-col :span="15">
                  <el-form-item label="项目名称" prop="name">
                    <el-input v-model="formData.name" placeholder="请输入项目名称" :maxlength="11" show-word-limit clearable
                      prefix-icon='el-icon-s-opportunity' :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="15">
                  <el-form-item label="备注">
                    <el-input v-model="formData.remark" placeholder="请输入备注" clearable
                      :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="17">
                  <el-form-item label="图片" prop="pics">
                    <el-upload class="upload-demo" drag action="/api/Upload/uploadFile/" :on-success="handleUploadSuccess"
                      :before-upload="beforeUpload" multiple :limit="1">
                      <i class="el-icon-upload"></i>

                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                      <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过1M</div>
                     
                    </el-upload>
                  </el-form-item>
                  <div v-if="imageUrl" style="text-align: center;" class="el-upload__text">图片如下</em></div>

                  <img v-if="imageUrl" :src="imageUrl" class="avatar" style="text-align: center;">
                </el-col>
              </el-form>
            </el-row>
            <div slot="footer">
              <el-button @click="close">取消</el-button>
              <el-button type="primary" @click="handleConfirm">确定</el-button>
            </div>
          </el-dialog>
        </div>
        <div class="table-box">
          <el-table :data="tabledata" border size="mini"
            :header-cell-style="{ background: '#f7f7f7', color: '#999', textAlign: 'center', fontWeight: 'normal' }">
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="name" label="名称描述" show-overflow-tooltip></el-table-column>
            <el-table-column prop="remark" label="备注" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="pics" label="图片" show-overflow-tooltip>
              <template slot-scope="s">
                <el-image style="width: 50px; height: 50px; margin-bottom:-4px" :src="s.row.pics" />
              </template>
            </el-table-column>
            <el-table-column prop="index" label="操作" width="210">
              <template slot-scope="s">
                <!-- <el-button type="warning" v-if="s.row.putaway" size="mini" @click="putaway(s.row)">下架</el-button>
                <el-button type="success" v-if="!s.row.putaway" size="mini" @click="putaway(s.row)">上架</el-button> -->
                <el-button type="danger" size="mini" @click="del(s.row)">删除</el-button>
                <el-button type="primary" size="mini" @click="edit(s.row)" plain>编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination class="page-tion" @current-change="currentChange" layout="prev, pager, next" :page-size="pagesize"
          :total="total" background>
        </el-pagination>
      </div>
    </Container>
    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
import Container from "../../../components/container"

export default {
  components: {
    Container,
  },
  data () {
    return {
      path: '/reallyWillBuy/facilities',
      search: {
        name: '',
      },
      dialogVisible: false,
      pageNo: 1,
      pagesize: 14,
      formData: {
        id:'',
        remark: '',          //备注
        name: '',             //项目名称
        pics: '',     // 图片
      },
      rules: {
        name: [{
          required: true,
          message: '请输入该项目图片名称',
          trigger: 'blur'
        }],
      },
      tabledata: [],
      total: 0,
      imageUrl: ''
    }
  },
  mounted () {

    this.getTableData();
  },
  methods: {
    edit (row) {
      console.log(row);
      this.dialogVisible = true
      this.formData = row
      this.imageUrl = row.pics
    },
    close () {
      this.dialogVisible = false
    },
    handleConfirm () {
      this.$refs['elForm'].validate(valid => {
        if (valid) {
          console.log(this.formData, '8888');
          var params = {
            id:this.formData.id,
            name: this.formData.name,
            remark: this.formData.remark,
            pics: this.formData.pics
          }
          this.$api.projectFacilityIconSubmission(params).then(res => {
            console.log(res,'=====');
            if (res === '添加成功' || res=== '修改成功') {
              this.$message.success(res);
              this.dialogVisible = false
            } 
    this.getTableData();

          })
        } else {
          this.$message.error('提交失败');
          this.dialogVisible = false
          return false;
        }
      })
    },
    beforeUpload (file) {
      let isRightSize = file.size / 1024 / 1024 < 1
      if (!isRightSize) {
        this.$message.error('文件大小超过 1MB')
      }
      let isAccept = new RegExp('image/*').test(file.type)
      if (!isAccept) {
        this.$message.error('应该选择image/*类型的文件')
      }
      return isRightSize && isAccept
    },
    // 文件上传成功时的钩子
    handleUploadSuccess (item, response) {
      let { data, errCode, msg } = response;
      console.log(data, 'data');
      console.log(item, 'item');

      if (item.msg === '上传成功') {
        this.$message.success('上传成功');
        this.formData.pics = item.data
        this.imageUrl = item.data

        this.$forceUpdate()
      } else {
        this.$message.error('上传失败');
      }
    },
    confirm () {
      this.pageNo = 1;
      this.getTableData();
    },
    currentChange (page) {
      this.pageNo = page;
      this.getTableData();
    },
    del (row) {
      this.$confirm("是否确定删除" + row.name).then(
        (confirm) => {
          var params = {
            id: row.id
          };
          this.$api.delprojectFacilityIconSubmission(params).then((data) => {
            this.$message.success(data);
            this.getTableData();
          });
        },
        (cancel) => { }
      );
    },
    getTableData () {
      var params = {
        name: this.search.name
      }
      this.$api.getprojectFacilityIconSubmission(params).then(data => {
        let { list, total } = data;
        this.tabledata = list;
        this.total = total;
      })
    },
  },

}
</script>

<style lang="scss" scoped>
.el-rate {
  display: inline-block;
  vertical-align: text-top;
}

.el-upload__tip {
  line-height: 1.2;
}

.right-edit-box {
  position: absolute;
  right: 0;
  top: 0;
}

.el-carousel__item {
  background: #fff;
  border: 1px dashed #999;

  .img {
    width: 270px;
    height: 202px;
    vertical-align: middle;
    position: relative;
  }

  .name {
    position: absolute;
    color: #fff;
    padding: 0 6px;
    background: rgba(0, 0, 0, 0.4);
    bottom: 4px;
    left: 4px;
  }
}

.left-row {
  border: 1px dashed #d9d9d9
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
  margin: 0 auto;
}
</style>